<div class="hub-modal-header">
    <div class="hub-modal-header-title">
        <div>{{ headerText }}</div>
        <div class="hub-modal-header-subtitle" *ngIf="headerSubText">{{ headerSubText }}</div>
    </div>
    <div class="hub-modal-header-actions">
        <hub-button
            [size]="'xl'"
            [style]="'outline'"
            [icon]="'cross'"
            (buttonClick)="activeModal.dismiss()"
        
        ></hub-button>
    </div>
</div>
